<template>
  <div class="body-main">
    <div class="header">
      <!--    <el-button size="mini" @click="editor()">添加</el-button>-->

      <el-input v-model="where2.keyword" style="width: 200px;margin-left: 10px;" size="mini" placeholder="请输入名称" clearable></el-input>

      <el-select v-model="where2.status" class="m-2" filterable placeholder="选择状态" clearable style="margin-left: 10px;" size="mini">
        <el-option
          v-for="item in [{name:'终止合作',value:0},{name:'合作中',value:1}]"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        />
      </el-select>
      <el-button size="mini" @click="exportThirdPartyExcel()">导出第三方填报表</el-button>
    </div>
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border
        style="width: 100%" height="60vh">
        <!--      <el-table-column-->
        <!--        prop="id"-->
        <!--        label="ID" width="80"></el-table-column>-->
        <el-table-column
          prop="project_name"
          label="项目"
          width="200">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="第三方单位名称" width="240"></el-table-column>
        <el-table-column
          prop="house_count"
          label="催缴户数"
          width="120" :formatter="intMilFormatter">
        </el-table-column>
        <el-table-column
          prop="house_money"
          label="催缴费用"
          width="150" :formatter="milFormatter">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="start_time"-->
<!--          label="开始时间"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="end_time"-->
<!--          label="结束时间"-->
<!--          width="150">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="company_day"-->
<!--          label="催费时长（天）"-->
<!--          width="150">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            {{scope.row.status?'合作中':'终止合作'}}
          </template>
        </el-table-column>
        <!--      <el-table-column-->
        <!--        prop="created_at"-->
        <!--        label="创建时间"-->
        <!--        width="100">-->
        <!--      </el-table-column>-->
        <el-table-column
          prop="updated_at"
          label="更新时间"
          width="100">
        </el-table-column>
        <el-table-column
          label="	操作"
          min-width="180">
          <template slot-scope="scope">
            <!--          <el-button type="primary" size="mini" @click="editor(scope.row)">编辑</el-button>-->
<!--            <el-button type="danger" size="mini" @click="stop(scope.row)">终止合作</el-button>-->
<!--            <el-button size="mini" @click="recrdHistory(scope.row)">移交历史</el-button>-->
            <el-link type="primary" @click="recrdHistory(scope.row)">移交历史</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-link type="primary" v-if="scope.row.task_id" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-link type="primary" @click="uploadeFile(scope.row)">上传移交证明</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-link type="primary" v-if="scope.row.file_id" @click="$refs.viewFileListRef.show(scope.row.file_id)">查看证明</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="95vw">

      <el-descriptions :column="2" size="mini" border :label-style="{width: '90px'}" :content-style="{width: 'calc(95vh - 200px)'}">
        <el-descriptions-item label="单位名称">
          {{formData.company_name}}
        </el-descriptions-item>
        <el-descriptions-item label="项目名称">
          {{formData.project_name}}
        </el-descriptions-item>
        <el-descriptions-item label="合作时长">
          {{formData.company_day}}
        </el-descriptions-item>
        <el-descriptions-item label="催费金额">
          {{formData.house_money}}
        </el-descriptions-item>
        <el-descriptions-item label="催费户数">
          {{formData.house_count}}
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          {{formData.status?'合作中':'终止合作'}}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>


      <template #footer>
        <div style="">
          <el-button size="mini" @click="dialogVisible=false">关 闭</el-button>
<!--          <el-button size="mini" @click="save">确认</el-button>-->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible2" :close-on-click-modal="false" @close="onClose" width="95vw">
      <ThirdPartyLitigationLegalHistory v-if="dialogVisible2" :id="formData.id" />
      <template #footer>
        <div style="">
          <el-button size="mini" @click="dialogVisible2=false">关 闭</el-button>
          <!--          <el-button size="mini" @click="save">确认</el-button>-->
        </div>
      </template>
    </el-dialog>
    <ViewFile ref="ViewFile" />
    <ViewFileList ref="viewFileListRef" />
    <ViewFlow ref="viewFlowRef" />
  </div>
</template>

<script>
import ViewFileList from "../../../Common/ViewFileList";
import ThirdPartyLitigationLegalHistory from "./ThirdPartyLitigationLegalHistory";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import ViewFile from "../../../Common/ViewFile";
export default {
  name: "ThirdPartyLitigationLegalHandoverRecord",
  components: {ViewFile, ViewFlow, ViewFileList,ThirdPartyLitigationLegalHistory},
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      where2:{
        keyword:"",
        status:1,
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      loading: false,
      formData:{
        name:"",
        head_name:"",
        telephone:"",
        status:1,
        remark:""
      },
      dialogVisible:false,
      dialogVisible2:false,
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)
      where = {
        ...where,
        ...ERP.reJson(that.where),
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        urge_type:that.urge_type,
        // area_id:that.areaId
      }

      ButlerHttp.post("ThirdPartyLitigation/getProjectCompanyList", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editor(item=null){
      const that=this;
      if(!item) {
        that.formData={
          name:"",
          head_name:"",
          telephone:"",
          status:1,
          remark:""
        }
      }else {
        that.formData=item;
      }
      that.dialogVisible=true;
    },
    stop(item){
      const that = this;
      that.$confirm('停止第三方合作的前提是当前合作商无催缴房产了，确定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = ERP.reJson(that.formData)
        ButlerHttp.post("ThirdPartyLitigation/getProjectCompanyStop", {
          id: formData.id
        }, res => {
          if (res.code) {
            that.pageChange(1);
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    save(){
      const that = this;
      that.loading = true;
      let formData = ERP.reJson(that.formData)
      ButlerHttp.post("ThirdPartyLitigation/getCollectionThridCompanyEditor", formData, res => {
        if (res.code) {
          that.dialogVisible = false;
          that.pageChange(1);
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    updateProjectCompany(formData){
      const that = this;
      ButlerHttp.post("ThirdPartyLitigation/updateProjectCompany", formData, res => {
        if (res.code) {
          that.$message.success(res.msg || '设置成功');
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },

    deleteItem(item){
      const that=this;

      ButlerHttp.post("ThirdPartyLitigation/getCollectionThridCompanyDel", {
        id: item.id
      }, res => {
        if (res.code) {
          that.getList();
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    onClose(){

    },
    recrd(item){
      const that = this;
      that.formData = ERP.reJson(item)
      that.dialogVisible = true;
    },
    recrdHistory(item){
      const that = this;
      that.formData = ERP.reJson(item)
      that.dialogVisible2 = true;
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    uploadeFile(item){
      const that = this;
      that.$refs.viewFileListRef.UploadFile(data=>{
        if(!item.file_id){
          that.updateProjectCompany({
            id:item.id,
            file_id:data.FileID,
          })
          item.file_id=data.FileID;
        }
        that.$message.success('上传成功')
      },item.file_id)
    },
    exportThirdPartyExcel(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        urge_type:that.urge_type,
      }
      let urlObj={
        2:"Litigation/exportExcel",
        3:"ThirdPartyLegal/exportExcel",
        4:"ThirdPartyLitigation/exportExcel"
      }
      if(!urlObj[that.urge_type]){
        that.$message.error("计划催缴类型异常无法导出");
        return false
      }
      ButlerHttp.post(urlObj[that.urge_type], {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "where2.keyword":function (n,o) {
      this.pageChange(1)
    },
    "where2.status":function (n,o) {
      this.pageChange(1)
    },
    "where.thrid_company_id":function (n,o) {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body-main{
  .header{
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
  }
  .pagination-wrap{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_litigation/ThirdPartyLitigationLegalHandoverRecord.vue